import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly tokenName = 'bearer_token';

  private _isAuthenticatedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public isAuthenticated$: Observable<boolean> = this._isAuthenticatedSubject.asObservable();

  constructor() {}

  // Function to set authenticated state to true
  login() {
    this._isAuthenticatedSubject.next(true);
  }

  // Function to set authenticated state to false
  logout() {
    this._isAuthenticatedSubject.next(false);
    this.clearBearerToken();
  }

  // Function to set the bearer token in localStorage
  setBearerToken(token: string) {
    localStorage.setItem(this.tokenName, token);
  }

  // Function to get the bearer token from localStorage
  getBearerToken(): string {
    return localStorage.getItem(this.tokenName) || '';
  }

  // Function to clear the bearer token from localStorage
  clearBearerToken() {
    localStorage.removeItem(this.tokenName);
  }
}
